import { z } from 'zod'

export const FormFolder = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  /** Convenience: how many forms currently live in this folder. */
  formCount: z.number().nullish(),
})
export type FormFolder = z.infer<typeof FormFolder>

export const CreateFormFolderParams = z.object({
  workspaceId: z.string(),
  name: z.string().min(1).max(255),
})
export type CreateFormFolderParams = z.infer<typeof CreateFormFolderParams>

export const UpdateFormFolderParams = z.object({
  id: z.string(),
  name: z.string().min(1).max(255),
})
export type UpdateFormFolderParams = z.infer<typeof UpdateFormFolderParams>

export const DeleteFormFolderParams = z.object({ id: z.string() })
export type DeleteFormFolderParams = z.infer<typeof DeleteFormFolderParams>

export const AssignFormToFolderParams = z.object({
  collectionId: z.string(),
  /** Pass `null` to remove the form from any folder ("All forms"). */
  folderId: z.string().nullable(),
})
export type AssignFormToFolderParams = z.infer<typeof AssignFormToFolderParams>
